// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__ZknpY","icon":"style_icon__3vQj6","badge":"style_badge__3dvj8"};